
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.172 14.078c1.745-.338 2.617-1.21 2.617-2.617 0-1.589-1.172-2.682-3.516-3.281-1.458-.365-2.187-.899-2.187-1.602 0-.39.17-.716.508-.976.364-.26.86-.391 1.484-.391 1.172 0 1.784.52 1.836 1.562h1.64c-.051-1.484-.846-2.421-2.382-2.812V2.32H7.945v1.64c-.755.156-1.38.469-1.875.937-.468.443-.703 1.016-.703 1.72 0 1.458 1.159 2.473 3.477 3.046 1.484.339 2.226.938 2.226 1.797 0 .338-.156.651-.468.937-.287.26-.795.391-1.524.391-1.38 0-2.122-.52-2.226-1.562H5.21c.078 1.484.99 2.421 2.734 2.812v1.64h2.227v-1.6zM3.102 3.141C4.742 1.5 6.708.68 9 .68s4.245.82 5.86 2.46C16.5 4.756 17.32 6.709 17.32 9c0 2.292-.82 4.258-2.46 5.898-1.615 1.615-3.568 2.422-5.86 2.422-2.292 0-4.258-.807-5.898-2.422C1.487 13.258.68 11.292.68 9s.807-4.245 2.422-5.86z","fill":"currentColor"}})])
          )
        }
      }
    